<div class="modal-header border-top-5-light-red">

    <h5 class="modal-title">{{'BlockedSlot.EditBlockedSlotTitle' | translate}} </h5>
</div>
<div class="modal-body bay-club-light-blue-2-bg">
    <div translate>
        BlockedSlot.EditBlockedSlotConfirm
    </div>

    <form [formGroup]="form" novalidate *ngIf="form" >

        <div class="cancel-blocked-slot-mode mt-2">
            <input id="just-this" type="radio" class="action-mode-input" [value]="editMode.thisEvent"
                formControlName="editMode">
            <label class="ml-1 action-mode-label" for="just-this"
                translate>BlockedSlot.EditBlockedSlotThisEvent</label>
        </div>

        <div class="cancel-blocked-slot-mode mt-1">
            <input id="this-and-following" type="radio" class="action-mode-input" [value]="editMode.thisAndFollowing"
                formControlName="editMode">
            <label class="ml-1 action-mode-label" for="this-and-following"
                translate>BlockedSlot.EditBlockedSlotThisAndFollowing</label>
        </div>

    </form>

</div>

<div class="modal-footer">
    <div class="d-flex justify-content-end">
        <button type="button" data-dismiss="modal" aria-label="Close" (click)="onDismiss()"
            class="btn btn-light-blue-outline btn-sm">{{'General.Dismiss' | translate}}</button>

        <button type="button" (click)="onConfirm()"
            class="btn btn-light-blue btn-sm ml-2">{{'General.Confirm' | translate}}</button>
    </div>
</div>